import { Flex, Box, Link as ChakraLink, Text, Image, Heading, Button } from "@chakra-ui/react";
import {
	Link as RouterLink
} from "react-router-dom";
import VerticalScroller from "../components/VerticalScroller/VerticalScroller";
import useAuthFunctions from "../hooks/useAuthFunctions";
import { useSetRecoilState } from 'recoil';
import { globalVideoPlayerOpenStatus, videoResource } from '../atoms/rootAtom';
// import { ExternalLinkIcon } from "@chakra-ui/icons";
// import VideoCarousel from "../components/VideoCarousel/VideoCarousel";
import LangSelect from "../components/NavBar/LangSelect";
import { useTranslation } from "react-i18next";
import { leftDrawerOpenStatus } from "../atoms/rootAtom";

function Home() {
	const { handleLogin, handleSignup } = useAuthFunctions();
	const setDrawerOpenStatus = useSetRecoilState(leftDrawerOpenStatus);
	const { t } = useTranslation();
	const showVideo = useSetRecoilState<boolean>(globalVideoPlayerOpenStatus);
	const setVideo = useSetRecoilState(videoResource);

	const openVideoPlayer = (video) => {
		showVideo(true);
		setVideo(video);
	}

	const Title = [
		"title1",
		"title2",
		"title3",
		"title4"
	];

	const Description = [
		"description1",
		"description2",
		"description3",
		"description4"
	];

	const handleLoginFn = () => {
		handleLogin();
	}

	const handleSignUpFn = () => {
		handleSignup();
	}

	return (
		<Flex flexDir={'row'} h={'full'} overflowY={'auto'}>
			<Box w={'70%'} h={'full'} p={10} pt={6} boxSizing={'border-box'}>
				<Box  ml={4} mb={6}>
					<Image
						w={'200px'}
						objectFit='cover'
						src='/static/doenba-logo.svg'
						alt='Doenba'
					/>
				</Box>

				<Box ml={4} py={2} >
					<Box color={'#000'} dangerouslySetInnerHTML={{ __html: t('doenba-intro') }}></Box>
					<Box mt={5}>
						<Button onClick={() => setDrawerOpenStatus(true)} w={'160px'} color="#fff" bgColor="#333" size={'lg'} _hover={{ bgColor: '#000' }} >{t('learn-more-btn')}</Button>
					</Box>
				</Box>
				<Box ml={4} my={2} mb={'2vh'}>
					{/* <VideoCarousel /> */}
					<Image  onClick={() => openVideoPlayer( { title: 'video-title-rqa', source: 'https://public-librum-files.s3.us-east-1.amazonaws.com/edit/en/Doenba+Edit+10+minute+intro.mp4' })} w='47vw' h={'47vh'} objectFit='cover' src="/static/home-video-bg.png" cursor={'pointer'} />
				</Box>
				<Flex ml={6} flexDir={'column'} w={'100%'} justifyContent={'center'}>
					<Box w={'95%'}>
						<VerticalScroller texts={Title} isTitle={true} />
						<VerticalScroller texts={Description} />
					</Box>
				</Flex>
			</Box>
			<Flex position={'absolute'} right={10} flexDir={'row'} justifyContent={'flex-end'} mt={5} px={5}>
				<LangSelect />
			</Flex>
			<Box
				bgImage={'url(/static/home-login-bg.png)'}
				w={'28%'} h={'82%'}
				bgSize={'100% 100%'}
				boxSizing={'border-box'}
				position={'absolute'}
				right={'3%'}
				top={`calc(57px + 3.6rem)`}
				px={'4%'}
			>
				<Flex pt={'4vh'} flexDir={'column'} justifyContent={'center'} alignItems={'center'} w={'full'} h={'calc(100% - 100px)'}>
					<Box mb='5'>
						<Heading as="h1" size="xl" mb={5}>
							{t('get-started-label')}
						</Heading>
						<Flex flexDir={'column'}>
							<Button onClick={handleLoginFn} mt="6vh" color="#fff" bgColor={'#333'} size={'lg'} _hover={{ bgColor: '#000' }} >
								{t('login-label')}
							</Button>
							<Button onClick={handleSignUpFn} mt="4vh" color="#fff" bgColor={'#1D8AFF'} _hover={{ bgColor: 'blue' }} size={'lg'}>
								{t('signup-label')}
							</Button>
						</Flex>
					</Box>
				</Flex>
				<Flex w={'full'} flexDir={'row'} justifyContent={'space-between'} alignItems={'center'}>
					<Box mr={'5'}>
						<Text>
							<ChakraLink as={RouterLink} to={"/terms-of-use"}>
								{t('terms-of-use-label')}
							</ChakraLink>
						</Text>
					</Box>
					<Box>
						<Text>
							<ChakraLink as={RouterLink} to={"/privacy-policy"}>
								{t('privacy-policy-label')}
							</ChakraLink>
						</Text>
					</Box>
				</Flex>
			</Box>
		</Flex>
	);
}

export default Home;
